import { CoinBadgeV2 } from "@components/CoinBadgeV2"
import { NftResponse } from "baaanggg"
import { Link } from "react-router-dom"
import { resolveImageUrl } from "@helpers/image.helper";

type Prop = {
    nft: NftResponse
}

export function NftCardV2({ nft }: Prop) {
    return <Link to={`/nft/${nft.collection?.slug}/${nft.tokenId}`}
        className="block rounded-2.5xl border border-jacarta-100 bg-white p-[1.1875rem] transition-shadow hover:shadow-lg dark:border-transparent dark:bg-gray-900">
        <figure className="relative">
            <img src={resolveImageUrl(nft.image)} alt="item 4" className="w-full rounded-[0.625rem]"
                loading="lazy" />

            <div className="absolute left-3 -bottom-3">
                <div className="flex -space-x-2">
                    {
                        nft.collection?.owner && <div>
                            <img src={resolveImageUrl(nft.collection.owner.thumbUrl ?? "/src/img/logo/transparant_logo.png")} alt="creator"
                                className="h-6 w-6 rounded-full border-2 border-white hover:border-accent dark:border-gray-400 dark:hover:border-jacarta-500"
                                data-tippy-content="Creator: Sussygirl" />
                        </div>
                    }

                    {
                        nft?.owner && <div>
                            <img src={resolveImageUrl(nft?.owner.thumbUrl ?? "/src/img/logo/transparant_logo.png")} alt="owner"
                                className="h-6 w-6 rounded-full border-2 border-white hover:border-accent dark:border-gray-400 dark:hover:border-jacarta-500"
                                data-tippy-content="Owner: Sussygirl" />
                        </div>
                    }



                </div>
            </div>
        </figure>
        <div className="mt-7 flex flex-wrap">
            {
                nft.transactions?.at(0)?.sell?.prices?.map(price => <div className="mr-1.5 mb-1.5" key={price.coinId}>
                    <CoinBadgeV2 size="sm" amount={price.price} coinId={price.coinId} />
                </div>
                )
            }
        </div>
        <div className="mt-2 flex items-center justify-between">
            <span className="font-display text-base text-jacarta-700 hover:text-accent dark:text-white">
                {nft.name}
            </span>
        </div>
    </Link>
}